import { Icon } from 'vopay';
import { useTranslation } from 'react-i18next';
import { Card, Button, Title } from 'UI';
import styles from './WorkflowToggleDialog.module.scss';

type Props = {
  onConfirm: () => void;
  onCancel: () => void;
};

export default function EditUncheckedToUncheckedDialog({ onConfirm, onCancel }: Props) {
  const { t: tGlobal } = useTranslation('translations', { keyPrefix: 'Global' });
  const { t } = useTranslation('translations', {
    keyPrefix: 'TransactionApproval.Configuration.Workflows.Update.EditDialog.UncheckedToUnchecked',
  });

  return (
    <Card hoverEffect={false} className={styles.card}>
      <div className={styles.iconWrapper}>
        <Icon icon="cautionary2" size="xxlg" width="60px" height="60px" color="none" />
      </div>

      <Title level="4" className={styles.title}>
        {t('title', { defaultValue: 'Update workflow' })}
      </Title>

      <div className={styles.body}>
        <p className={styles.subtitle}>
          {t('subtitle', {
            defaultValue: 'Saving these changes will update the workflow on this account only.',
          })}
        </p>
        <ul className={styles.bullets}>
          <li>
            {t('bullet1', {
              defaultValue: 'Any transactions still collecting approvals will be re-evaluated against the new rules.',
            })}
          </li>
          <li>
            {t('bullet2', {
              defaultValue: "Transactions already approved and queued for processing aren't affected.",
            })}
          </li>
        </ul>
        <p className={styles.footer}>{t('footer', { defaultValue: "Sub-accounts aren't affected." })}</p>
      </div>

      <div className={styles.controls}>
        <Button colorScheme="secondary" size="small" onClick={onCancel}>
          {tGlobal('Buttons.cancel', { defaultValue: 'Cancel' })}
        </Button>
        <Button colorScheme="primary" size="small" onClick={onConfirm}>
          {t('confirmButton', { defaultValue: 'Confirm' })}
        </Button>
      </div>
    </Card>
  );
}
